var map = {
	"./blue50.png": 45,
	"./blue60.png": 46,
	"./blue70.png": 47,
	"./darkblue30.png": 48,
	"./darkblue50.png": 49,
	"./darkblue70.png": 50,
	"./green50.png": 51,
	"./green60.png": 52,
	"./green70.png": 53,
	"./grey40.png": 54,
	"./grey70.png": 55,
	"./grey80.png": 56,
	"./red50.png": 57,
	"./red60.png": 58,
	"./red70.png": 59,
	"./yellow50.png": 60,
	"./yellow60.png": 61,
	"./yellow70.png": 62
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 44;